import React from "react";
import classes from "./bulkSpareDetailHead.module.css";
import { dateFormatter } from "../../../../utils/dateFormatter";
import { StatusBadge } from "./BulkSpareDetailForm";
import { HotSellingToggle } from "../../../hotSelling/HotSellingToggle";

export const BulkSpareDetailHead = React.memo(
  ({ lot_name, uploaded_on, approval_status, isHotSelling, onChange }) => {
    return (
      <div className={classes.box__section}>
        {/* LEFT */}
        <div className={classes.left}>
          <h1 className={classes.title}>{lot_name || "—"}</h1>

          <span className={classes.date}>
            Uploaded on {uploaded_on ? dateFormatter(uploaded_on) : "—"}
          </span>

          <StatusBadge status={approval_status} />
        </div>

        {/* RIGHT */}
        <div className={classes.right}>
          <HotSellingToggle
            value={isHotSelling}
            onChange={onChange}
            aria-label="Toggle Hot Selling"
          />
        </div>
      </div>
    );
  },
);
